import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	HostBinding,
	Input,
	Output,
	ViewEncapsulation,
} from "@angular/core";
import { UiInteraction } from "@obg/ngx.core";
import { MenuItem } from "@obg/ngx.core.content";
import { coerceBoolean } from "@obg/ngx.global.evo";
import { RouteLinkActiveOptions } from "@obg/ngx.router";

import { MenuConfigService } from "./menu.config";

interface ItemSelectedEvent {
	item: MenuItem;
	sectionName: string;
}

@Component({
	selector: "obg-menu",
	templateUrl: "./menu.component.html",
	styleUrls: ["./menu.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class MenuComponent {
	@HostBinding("class.obg-menu") hostCssClass = true;

	@Input() @HostBinding("attr.role") role = "list";
	@Input() menuItems: MenuItem[] = [];
	@Input() routeLinkActiveOptions: RouteLinkActiveOptions | undefined;
	@Input() uiInteraction: UiInteraction | undefined;
	@Input() @coerceBoolean() matchExact = false;
	@Input() @coerceBoolean() hideIcons = false;

	@Output() selectedItem = new EventEmitter<ItemSelectedEvent>();

	private readonly routesWithoutExactMatch = this.configService.getUrlsWithoutExactMatch();

	constructor(private configService: MenuConfigService) {}

	trackByKey(_index: number, menu: MenuItem): string {
		return menu.key;
	}

	itemRouteLinkActiveOptions(item: MenuItem): RouteLinkActiveOptions {
		return {
			...this.routeLinkActiveOptions,
			matchExact: !item.route || (this.matchExact && !this.routesWithoutExactMatch.includes(item.route)),
		};
	}
}
